// @flow

export const styles = {
  container: {
    background: '#2F3755'
  },
  padding: {
    padding: 4
  },
  paragraph: {
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    fontSize: 12,
    color: 'white'
  },
  link: {
    color: 'white'
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Styles/Banner.Style.js